(() => {
  if (!window.idealPdpCartGestureInstalled) {
    window.idealPdpCartGestureInstalled = true;
    let gesture;
    const buttonFor = target => target instanceof Element ? target.closest('[data-ideal-pdp] [data-product-atc], [data-ideal-pdp] [data-ideal-pdp-history-order-again]') : null;
    const start = (event, point, id) => {
      gesture = { button: buttonFor(event.target), id, x: point.clientX, y: point.clientY, moved: false, cancelled: false, released: false, time: performance.now() };
    };
    const update = (point, id, released) => {
      if (!gesture || gesture.id !== id) return;
      if (Math.hypot(point.clientX - gesture.x, point.clientY - gesture.y) > 10) gesture.moved = true;
      if (!released) return;
      gesture.released = true;
      gesture.time = performance.now();
      const bounds = gesture.button?.getBoundingClientRect();
      if (bounds && (point.clientX < bounds.left || point.clientX > bounds.right || point.clientY < bounds.top || point.clientY > bounds.bottom)) gesture.cancelled = true;
    };
    if ('PointerEvent' in window) {
      window.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        if (event.isPrimary === false) { if (gesture) gesture.cancelled = true; return; }
        start(event, event, event.pointerId);
      }, { capture: true, passive: true });
      window.addEventListener('pointermove', event => update(event, event.pointerId, false), { capture: true, passive: true });
      window.addEventListener('pointerup', event => update(event, event.pointerId, true), { capture: true, passive: true });
      window.addEventListener('pointercancel', event => {
        if (gesture && gesture.id === event.pointerId) { gesture.cancelled = true; gesture.time = performance.now(); }
      }, { capture: true, passive: true });
    } else {
      window.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { if (gesture) gesture.cancelled = true; return; }
        start(event, event.touches[0], event.touches[0].identifier);
      }, { capture: true, passive: true });
      window.addEventListener('touchmove', event => {
        for (const point of event.changedTouches) update(point, point.identifier, false);
      }, { capture: true, passive: true });
      window.addEventListener('touchend', event => {
        for (const point of event.changedTouches) update(point, point.identifier, true);
      }, { capture: true, passive: true });
      window.addEventListener('touchcancel', () => {
        if (gesture) { gesture.cancelled = true; gesture.time = performance.now(); }
      }, { capture: true, passive: true });
    }
    window.addEventListener('scroll', () => {
      if (gesture && !gesture.released) gesture.moved = true;
    }, { capture: true, passive: true });
    window.addEventListener('keydown', event => {
      if (buttonFor(event.target) && (event.key === 'Enter' || event.key === ' ')) gesture = null;
    }, true);
    window.addEventListener('click', event => {
      const button = buttonFor(event.target);
      if (!button) return;
      const touchClick = event.pointerType === 'touch' || event.pointerType === 'pen' || event.sourceCapabilities?.firesTouchEvents;
      if ((event.detail === 0 && !touchClick) || (event.pointerType === 'mouse' && !touchClick)) return;
      if (!gesture || performance.now() - gesture.time > 1200) return;
      const valid = gesture.button === button && gesture.released && !gesture.moved && !gesture.cancelled;
      gesture = null;
      if (!valid) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
  }
  function initialise(root) {
    root.querySelectorAll('[data-ideal-pdp]').forEach(section => {
      if (section.dataset.idealPdpReady) return;
      section.dataset.idealPdpReady = 'true';
      const status = section.querySelector('[data-ideal-pdp-copy-status]');
      let statusTimer;
      let copyRequest = 0;
      section.addEventListener('click', async event => {
        const button = event.target.closest('[data-ideal-pdp-copy]');
        if (!button || !section.contains(button)) return;
        const number = button.closest('.ideal-pdp-reference')?.querySelector('[data-ideal-pdp-number]');
        const value = number?.textContent.trim();
        if (!value) return;
        const request = ++copyRequest;
        clearTimeout(statusTimer);
        section.querySelectorAll('[data-ideal-pdp-copy].is-copied').forEach(previous => previous.classList.remove('is-copied'));
        status.classList.remove('is-visible');
        status.textContent = '';
        try {
          await navigator.clipboard.writeText(value);
          if (request !== copyRequest) return;
          status.textContent = status.dataset.copiedText;
          button.classList.add('is-copied');
        } catch {
          if (request !== copyRequest) return;
          const range = document.createRange();
          range.selectNodeContents(number);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          status.textContent = status.dataset.selectText;
        }
        status.classList.add('is-visible');
        statusTimer = setTimeout(() => {
          status.classList.remove('is-visible');
          status.textContent = '';
        }, 2600);
      });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

